<template>
    <Section width="md">
        <section-header :title="slice.primary.header" />
        <ul class="grid faq-grid">
            <li v-for="question in questions" :key="question.id">
                <expand 
                    class="author-expander" 
                    @expander-toggled="toggleExpandedQuestionIds(question.id)"
                >
                    <template #button>
                        <user-question 
                            :question="question" 
                            :author="getAuthor(question.data.author.id)" 
                            :show-icon="false" 
                            :truncate-text="!expandedQuestionIds.has(question.id)"
                        />
                    </template>
                    <div class="rich-text" v-html="$prismic.asHtml(question.data.answer)" />
                </expand>
            </li>
        </ul>
        <nuxt-link
            v-if="showFaqPageLink" 
            :to="faqPageLink"
            class="btn btn-sm btn-green-border faq-page-button" 
        >
            {{ $translate('faq_page_link_text', 'Ställ din fråga') }}
        </nuxt-link>
    </Section>
</template>

<script>
import Expand from '@/components/slices/list/list-item/list-item-components/Expand.vue';
import UserQuestion from '@/components/UserQuestion.vue';
export default {
    components: {
        Expand,
        UserQuestion
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            questions: [],
            limit: this.slice.primary.limit || 4,
            includeFaqPageLink: this.slice.primary.include_faq_page_link,
            expandedQuestionIds: new Set()
        };
    },
    async fetch () {
        this.questions = (await this.$prismic.api.query(
            [
                this.$prismic.predicates.at('document.type', 'question_answer'),
            ],
            { 
                orderings: '[document.last_publication_date desc]',
                lang: process.env.PRISMIC_LOCALE,
                pageSize: this.limit
            }
        )).results;
    },
    fetchKey() {
        return `latest-user-questions-${this.slice.id}`;
    },
    computed: {
        faqPageLink() {
            const settings = this.$store.state.settings;
            return this.$validateContentRelationship(settings.faq_page_link) 
                ? this.$prismic.linkResolver(settings.faq_page_link) 
                : null;
        },
        showFaqPageLink() {
            return this.includeFaqPageLink && this.faqPageLink;
        }
    },
    methods: {
        getAuthor(id) {
            return this.$store.state.authors[id];
        },
        toggleExpandedQuestionIds(id) {
            if (this.expandedQuestionIds.has(id)) {
                this.expandedQuestionIds.delete(id);
            }
            else {
                this.expandedQuestionIds.add(id);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
ul {
    margin-bottom: 30px;
    li {
        &:not(:last-child) {
            @include border(bottom);
        }
    
        .author-expander::v-deep {    
            .expand-row__button {
                @include spacing(padding,6,(left,right));
                @include spacing(padding,4,(top,bottom));
            }
            .expand-row__content {
                background-color: $graybg;
                @include spacing(padding,6,(left,right));
    
                li {
                    @include font-size(14px,8px);
                }
                
                > div:last-child {
                    @include spacing(padding, 4, bottom);
                }
    
            }
        }
    }
}
.faq-page-button {
    width: fit-content;
    @include spacing(margin,1,left);
}
</style>